import { capitalize } from 'lodash';

import { formatDate, formatPhoneNumber } from 'lib/helpers/utility';

import { PATIENT_OPTIONS, TAG_CHARTS_OPTIONS } from 'components/shared/Filters/lib/filterOptions';
import TagsCell from 'components/shared/Tags/components/Cell/TagsCell';

export const patientStatuses = [
  {
    value: 'active',
    label: 'Active'
  },
  {
    value: 'inactive',
    label: 'Inactive'
  }
];

export const defaultColumns = [
  {
    field: 'id',
    headerName: 'Chart ID',
    checkboxSelection: true,
    headerCheckboxSelection: true
  },
  {
    field: 'f_name',
    headerName: 'First Name',
    valueFormatter: ({ value }) => capitalize(value)
  },
  { field: 'l_name', headerName: 'Last Name', valueFormatter: ({ value }) => capitalize(value) },
  {
    field: 'p_name',
    headerName: 'Preferred Name',
    valueFormatter: ({ value }) => capitalize(value)
  },
  {
    field: 'dob',
    headerName: 'Date of Birth',
    valueFormatter: ({ value }) => formatDate(value)
  },
  { field: 'email', headerName: 'Email' },

  {
    field: 'phone',
    headerName: 'Phone',
    valueFormatter: ({ value }) => formatPhoneNumber(value)
  },
  {
    field: 'status',
    headerName: 'Status',
    valueGetter: (params) => {
      return params?.data?.practicePatientLink?.status;
    },
    valueFormatter: ({ value }) => capitalize(value)
  },
  {
    field: 'tagLinks',
    headerName: 'Tags',
    cellClass: 'no-border',
    minWidth: 300,
    cellRenderer: ({ value, data }) => (
      <TagsCell
        value={value}
        kind="chart"
        label="patient's chart"
        data={data}
        refTable="user"
        query={{ keys: ['patients'], object: 'patients' }}
      />
    ),
    sortable: false
  }
];

export const defaultFilters = {
  patient: PATIENT_OPTIONS,
  status: {
    title: 'Status',
    placeholder: 'Search by status',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: patientStatuses.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'patient_chart_statuses.options',
    icon: 'status-mono'
  },
  tag: TAG_CHARTS_OPTIONS
};
